import React, { useState } from "react";
import WindowHeader from "../Layout/WindowHeader/WindowHeader";
import headeLogo from "../../assets/images/shersoftnavLogo.png";
import { useDbContext } from "../../context/DbContext";
import axios from "axios";

function RenameLedger({ onClose, LedName }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const [newLedname, setNewLedname] = useState(LedName);

  const handleUpdate = async () => {
    if (!newLedname || newLedname.trim() === "") {
      alert("Enter New Ledger Name");
      return;
    }
    try {
      const response = await axios.put(
        `${apiBaseUrl}/main/renameLed/${dbCode}`,
        {
          LedName: LedName,
          newLedname: newLedname.trim()
        }
      );

      if (response.status === 200) {
        alert("Ledger Renamed");
        onClose();
      } else {
        console.error("Error updating data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-[9999] pointer-events-auto">
      <div className="w-[420px] bg-white border border-[#b8cce0] shadow-2xl rounded-[6px] overflow-hidden flex flex-col">
        <WindowHeader
          title="Rename Ledger"
          logo={headeLogo}
          onClose={onClose}
          closeBtnClassName="w-6 h-6 border-none rounded-[5px] mr-2"
        />

        <div className="p-5 flex flex-col gap-4">
          {/* Old Ledger */}
          <div className="flex flex-col gap-1.5">
            <label className="text-[13px] font-semibold text-[#334155]">
              Old Ledger
            </label>
            <input
              type="text"
              className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none bg-gray-50 text-gray-500 cursor-not-allowed box-border"
              style={{ height: "34px" }}
              readOnly
              value={LedName}
            />
          </div>

          {/* New Ledger */}
          <div className="flex flex-col gap-1.5">
            <label className="text-[13px] font-semibold text-[#334155]">
              New Ledger <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter new ledger name"
              className="w-full px-3 text-[13px] border border-[#cbd5e1] rounded-[4px] outline-none focus:border-[#1a3abf] box-border font-Inter"
              style={{ height: "34px" }}
              value={newLedname}
              onChange={(e) => setNewLedname(e.target.value)}
            />
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end gap-2 mt-2">
            <button
              onClick={handleUpdate}
              className="px-5 text-[13px] font-semibold text-white bg-[#1a3abf] hover:bg-blue-800 rounded-[4px] transition-colors border-none cursor-pointer"
              style={{ height: "34px" }}
            >
              Rename
            </button>
            <button
              onClick={onClose}
              className="px-5 text-[13px] font-semibold text-[#334155] bg-[#EAF0FC] hover:bg-blue-100 rounded-[4px] transition-colors border-none cursor-pointer"
              style={{ height: "34px" }}
            >
              Exit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RenameLedger;

